// Download permissions can arrive after the button is mounted. Keep the
// existing permission membership rule reactive instead of taking a one-time
// sessionStorage snapshot and removing Vue-owned nodes.
const buttons = new WeakMap();

export default {
  bind(el, binding, vnode) {
    const store = vnode.context.$store;
    const entry = { need: Number(binding.value), display: el.style.display };
    entry.apply = permissions => {
      const allowed = Array.isArray(permissions)
        && permissions.some(permission => permission && permission.funcId === entry.need);
      el.style.display = allowed ? entry.display : 'none';
    };
    entry.stop = store.watch(state => state.levelList, entry.apply, { immediate: true });
    buttons.set(el, entry);
  },
  update(el, binding, vnode) {
    const entry = buttons.get(el);
    if (entry && binding.value !== binding.oldValue) {
      entry.need = Number(binding.value);
      entry.apply(vnode.context.$store.state.levelList);
    }
  },
  unbind(el) {
    const entry = buttons.get(el);
    if (entry) entry.stop();
    buttons.delete(el);
  },
};
